module.exports = __webpack_public_path__ + "img/no-image.46a8a19.png";